<template>
  <div class="component-wrap">

    <div class="main-box">
      <div class="head-box">
        <div class="ins"></div>
        <div class="bold">税款所属期：</div>
        <div class="red">2023年10月</div>
        <div class="normal">（当期可进行勾选操作的截止日期为：2023年11月15日）</div>
        <div class="grow"></div>
        <el-button type="primary" round
                   style="color: #FFFFFF;width: 80px;"
                   color="#15acee"
                   @click="queryData(true)"
        >查询
        </el-button>
      </div>

      <div class="query-wrapper">
        <div class="item">
          <span class="label">发票类别：</span>
          <el-radio-group v-model="queryParams.mainType">
            <el-radio label="增值税专用发票" value="1"/>
            <el-radio label="海关缴款书" value="2" disabled/>
          </el-radio-group>
        </div>

        <div class="item">
          <span class="label">发票代码：</span>
          <el-input
              readonly
              v-model="queryParams.invoiceCode"
              style="width: 150px;"
          />

          <span class="label has-margin">发票号码：</span>
          <el-input
              readonly
              v-model="queryParams.invoiceNumber"
              style="width: 150px;"
          />

          <span class="label has-margin">开票日期：</span>
          <date-range-picker
              v-model:start-field="queryParams.kpStart"
              v-model:end-field="queryParams.kpEnd"
              unlink-panels
              clearable
              readonly
              range-separator="-"
              start-placeholder=" "
              end-placeholder=" "
              style="width: 300px;flex-grow: 0;"
          />

          <span class="label has-margin">销方税号：</span>
          <el-input
              readonly
              v-model="queryParams.saleCode"
              style="width: 150px;"
          />
        </div>

        <div class="item">
          <span class="label">勾选状态：</span>
          <el-radio-group v-model="queryParams.checked">
            <el-radio label="未勾选" value="0"/>
            <el-radio label="已勾选" value="1"/>
          </el-radio-group>
        </div>

        <div class="item">
          <span class="label">发票类型：</span>
          <el-radio-group v-model="queryParams.invoiceType">
            <el-radio label="全部" value="0"/>
            <el-radio label="增值税专用发票" value="1"/>
            <el-radio label="机动车发票" value="2" disabled/>
            <el-radio label="通行费电子发票" value="3" disabled/>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="gray-ge"></div>

    <div class="main-box">
      <div class="head-box">
        <div class="ins"></div>
        <div class="bold">发票勾选</div>
        <div class="normal">（当期可勾选发票的开票日期范围为：2019年01月01日 - 2023年10月30日）</div>
      </div>

      <div class="main-op">
        <el-table
            ref="tableRef"
            :data="tableList"
            @selection-change="handleTableSelect"
        >
          <el-table-column type="selection" label="勾选" fixed="left" align="center" width="60"/>

          <el-table-column label="全电发票号码" align="center" fixed="left" prop="allInvoiceNumber" width="160"/>

          <el-table-column label="发票代码" align="center" fixed="left" prop="invoiceCode" width="160"/>

          <el-table-column label="发票号码" align="center" prop="invoiceNumber" width="160"/>

          <el-table-column label="开票日期" align="center" prop="invoiceDate" width="180"/>

          <el-table-column label="销方名称" align="center" prop="sellerName" width="200"/>

          <el-table-column label="销方税号" align="center" prop="sellerCode" width="160"/>

          <el-table-column label="金额" align="center" prop="amount" width="120">
            <template #default="{row}">
              <span>{{ row.amount.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="税额" align="center" prop="taxAmount" width="120">
            <template #default="{row}">
              <span>{{ row.taxAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="有效税额" align="center" prop="effectiveTaxAmount" width="120">
            <template #default="{row}">
              <span>{{ row.effectiveTaxAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="发票状态" align="center" prop="invoiceStatus" width="120"/>

          <el-table-column label="发票类型" align="center" prop="invoiceType" width="140"/>

          <el-table-column label="信息来源" align="center" prop="infoSource" width="80"/>

          <el-table-column label="是否勾选" align="center" prop="checked" width="80">
            <template #default="{row}">
              <span v-if="queriedParams.checked == '0'">未勾选</span>
              <span v-else-if="queriedParams.checked == '1'">已勾选</span>
            </template>
          </el-table-column>

          <el-table-column label="勾选时间" align="center" prop="checkTime" width="200">
            <template #default="{row}">
              <span>2022-07-31 00:00:00	</span>
            </template>
          </el-table-column>

          <el-table-column label="管理状态" align="center" prop="manageStatus" width="80">
            <template #default="{row}">
              <span>正常</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" prop="score" width="120">
            <template #default="{row}">
              <el-button type="danger" link
                         @click="seeDetail(row)"
              >查看明细信息
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="opera">
          <el-button type="primary"
                     round
                     :disabled="!Boolean(selectRows.length) || queriedParams.checked == '1'"
                     color="#17cacb"
                     style="color: #FFFFFF;width: 80px;"
                     @click="submit"
          >提交
          </el-button>
        </div>
      </div>
    </div>

    <div class="gray-ge"></div>

    <div class="main-box">
      <div class="head-box">
        <div class="ins"></div>
        <div class="bold">备注</div>
      </div>

      <div class="note-txt">
        1、除发票状态、管理状态为正常外，其他异常发票不允许勾选；<br/>
        2、对于勾选为抵扣的发票默认全额抵扣，您可根据实际情况自行调整有效抵扣税额，请注意：差额部分将不可继续勾选为其他用途；<br/>
        3、对于信息来源为扫描认证的发票，支持撤销勾选操作，再次勾选时，税款所属期归属在勾选提交时的当期；<br/>
        4、对于已勾选的发票，您可以在这里撤销勾选，但在申报期内，如您已经在“抵扣勾选统计”模块进行了申请统计，系统将锁定当期的勾选操作；如需继续勾选发票，可在撤销统计成功后继续进行发票勾选或撤销勾选；<br/>
        5、本模块支持查询当期可勾选范围内已勾选和未勾选的发票。往期认证和未到认证期的发票，请前往进项发票查询模块的“单票查询”和“未到勾选日期发票查询”进行查询。
      </div>
    </div>


  </div>
</template>

<script setup lang="jsx">
import DateRangePicker from "@/components/EnhanceForm/DateRangePicker.vue";
import {ElMessage, ElMessageBox} from "element-plus";
import Big from "big.js";
import {$emit, $on} from "vue-happy-bus";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const queryParams = reactive({
  mainType: '1',
  checked: '0',
  invoiceType: '0',
})
const tableList = ref([])

let queriedParams = ref({}) // 已经查询的查询参数，接口执行后自动赋值

// 点击查询
function queryData(byUser) {
  const initialData = JSON.parse(props.currentQa.initialAnswer || "[]")
  queriedParams.value = JSON.parse(JSON.stringify(queryParams))
  if (queryParams.checked == '0') { // 未勾选数据查询
    tableList.value = initialData
        .filter(f => !checkedRows.some(s => s.invoiceCode === f.invoiceCode));
  } else if (queryParams.checked == '1') {
    tableList.value = checkedRows
  }
  if (!byUser) {
    return
  }
  ElMessageBox.alert('查询成功', '提示', {
    confirmButtonText: 'OK',
    showClose: false,
    callback: () => {
    },
  })
}

function seeDetail() {
  ElMessageBox.alert('此功能不在实训范围内', '提示', {
    confirmButtonText: 'OK',
    showClose: false,
    callback: () => {
    },
  })
}

const tableRef = ref()
const selectRows = ref([])

function handleTableSelect(rows) {
  selectRows.value = rows
}

function submit() {
  const rows = tableRef.value.getSelectionRows()
  if (!rows || rows.length === 0) {
    ElMessage.error('请先勾选发票!')
    return
  }
  let amountTotal = new Big(0), taxAmountTotal = new Big(0), effectiveTaxAmountTotal = new Big(0)

  rows.forEach(row => {
    amountTotal = amountTotal.plus(row.amount)
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount)
    effectiveTaxAmountTotal = effectiveTaxAmountTotal.plus(row.effectiveTaxAmount)
  })
  const vnode = (
      <div style="color:#333333;line-height:18px;letter-spacing: 0.3px;">
        <div style="font-weight: 700;">本次勾选发票汇总如下：</div>
        <br/>

        <div style="text-indent: 2em">本次勾选<span style="color: red;">{rows.length}</span>份，
          金额合计<span style="color: red;">{amountTotal.toString()}</span>元，
          税额合计：<span style="color: red;">{taxAmountTotal.toString()}</span>元，
          有效税额合计：<span style="color: red;">{effectiveTaxAmountTotal.toString()}</span>元
        </div>

        <br/>
        <div style="font-weight: 700;">请确认是否提交？</div>
      </div>
  );
  ElMessageBox.alert(vnode, '流程说明', {
    cancelButtonText: '取消',
    showCancelButton: true,
  })
      .then(() => {
        $emit('exeSaveQa')
      })
      .catch(() => {
      })
}

let checkedRows = [] // 已勾选，保存到服务器的列

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  if (res.byUser) {
    checkedRows = JSON.parse(res?.serverData?.solution || "[]")
    queryData(false)
    ElMessageBox.alert('数据保存成功！', '提示', {
      confirmButtonText: 'OK',
      showClose: false,
    })
        .finally(() => {
        })
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = () => {
  const rows = tableRef.value.getSelectionRows()
  return {
    solution: rows.concat(checkedRows).length && JSON.stringify(rows.concat(checkedRows)) || '',
  }
}
getGrandchildValue.value.fillFinish = () => {
  return Boolean(checkedRows.length)
}

onMounted(() => {
  checkedRows = JSON.parse(props.currentQa?.solution || "[]")
})
</script>


<style scoped lang="scss">
.component-wrap {
  font-size: 14px;
  color: #333333;

  .gray-ge {
    width: 1200px;
    margin: auto;
    height: 15px;
    background-color: #f7f7f7;
  }

  .head-box {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ebebeb;

    .ins {
      width: 5px;
      height: 21px;
      background-color: #16307a;
      margin-right: 12px;
    }

    .bold {
      color: #333333;
      font-size: 16px;
      font-weight: 700;
    }

    .red {
      color: #d75452;
      font-size: 16px;
      font-weight: 700;
    }

    .normal {
      font-weight: 400;
      color: #666666;
      font-size: 14px;
    }

    .grow {
      flex-grow: 1;
    }
  }

  .main-box {
    padding: 20px 0;

    .note-txt {
      line-height: 28px;
      color: #666666;
    }

    .query-wrapper {

      :deep(.item) {
        display: flex;
        align-items: center;
        padding-bottom: 10px;

        .label {
          flex-shrink: 0;

          &.has-margin {
            margin-left: 15px;
          }
        }

        .el-radio__label {
          color: #333333;
        }

        .el-radio__inner.el-radio__inner {
          &::after {
            cursor: pointer;
            background-color: #FFFFFF;
          }

          //border-color: #FFFFFF;
        }
      }
    }

    .main-op {
      .opera {
        padding-top: 20px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
